export const FONT_WEIGHTS = {
    default: 900,
    bold: 700,
    medium: 500,
    light: 450,
} as const;
